import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
    connect,
    Provider,
} from 'react-redux';
import { bindActionCreators } from 'redux';
import { ConnectedRouter } from 'connected-react-router';

import { createHashHistory as createHistory } from 'history';

import initReactApp, { extractParams } from 'helpers/InitHelpers';

import configureStore from './Store';

import GodBuster from '../components/GodBuster';

import {
    initContactSupportApp,
} from './reduxModules/App';

import SupportContent from './components/SupportContent';
import ConsentManagementPlatformPortal from '../consentManagementPlatform/ConsentManagementPlatformPortal';

export const appSelector = '#js-app-contact-form';

class SupportStandAlone extends Component {

    componentDidMount() {
        const { AppActions } = this.props;
        AppActions.initContactSupportApp();
    }

    render() {
        const { history } = this.props;
        return (
            <GodBuster>
                <ConnectedRouter history={history}>
                    <>
                        <SupportContent />
                        <ConsentManagementPlatformPortal />
                    </>
                </ConnectedRouter>
            </GodBuster>
        );
    }

}

SupportStandAlone.propTypes = {
    AppActions: PropTypes.shape({
        initContactSupportApp: PropTypes.func.isRequired,
    }).isRequired,
    history: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
};

SupportStandAlone.defaultProps = {
};

function mapStateToProps(state, ownProps) {
    return {
        location: ownProps.history.location,
    };
}

const ConnectedApp = connect(mapStateToProps, (dispatch) => ({
    AppActions: bindActionCreators({
        initContactSupportApp,
    }, dispatch),
}))(SupportStandAlone);

export default ConnectedApp;

export function initContactFormApp() {
    if (!document.querySelector(appSelector)) return;
    const params = extractParams(appSelector);
    const history = createHistory();
    const store = configureStore({
        AppFormContact: {
            orgaId: Number.parseInt(params['orga-id'], 10),
            currentEventType: '',
            currentPhone: '',
            currentEmail: '',
            currentMessage: '',
            currentName: '',
            currentQuestionType: '',
            questionErrorsDisplayed: false,
            isSending: false,
        },
    }, history);
    initReactApp(appSelector, (
        <Provider store={store}>
            <ConnectedApp
                history={history}
                /* eslint-disable-next-line react/jsx-props-no-spreading */
                {...params}
            />
        </Provider>
    ), true);
}

initContactFormApp();
